import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Container } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography'

import LanguageButton from '../components/LanguageButton'
import MenuButton from '../components/MenuButton'
import Title from '../components/Title'
import Text from '../components/Text'


import logo from '../images/Footer/Laimburg_logo.png'
import symptome from '../images/icones/symptome_erkennen.png'
import meldung from '../images/icones/eine_meldung_machen.png'

import linkedin from '../images/Footer/Linkedin.png'
import instagram from '../images/Footer/Instagram.png'
import facebook from '../images/Footer/Facebook.png'
import youtube from '../images/Footer/Youtube.png'


export default function Footer3() {

  const { t } = useTranslation();

  return (
    
    <Container className="footer pb-4">

      <Grid container
        className="pt-4"
        justifyContent="space-between"
        spacing={4}
      >
        <Grid container flexDirection="column" spacing={2} justifyContent="center">
          <Grid container flexDirection="row" spacing={2}>
            <Text variant="bold" text="questions" color="white" sx={{ paragraph: false }}></Text>
            <Text variant="bold" text="ask" color="white" sx={{ paragraph: false }}></Text>
          </Grid>

          <Grid container flexDirection="row" justifyContent="flex-start" alignItems="center" spacing={2}>
            <Grid>
              <Text variant="bold" text="follow_us" color="white"></Text>
            </Grid>
            <Grid>
              <Link to="https://www.linkedin.com/company/laimburg-research-centre/">
                <img className="w-5" src={linkedin} />
              </Link>
            </Grid>
            <Grid>
              <Link to="https://www.instagram.com/laimburg.researchcentre/#">
                <img className="w-5" src={instagram} />
              </Link>
            </Grid>
            <Grid>
              <Link to="https://www.facebook.com/Laimburg.Research.Centre">
                <img className="w-5" src={facebook} />
              </Link>
            </Grid>
            <Grid>
              <Link to="https://www.youtube.com/c/LaimburgResearchCentre">
                <img className="w-5" src={youtube} />
              </Link>
            </Grid>
          </Grid>


        </Grid>

        <Grid container flexDirection="column" spacing={1} alignItems="center">
          <Grid>
            <img src={logo} className="w-40" />
          </Grid>
          <Grid alignSelf="flex-end">
            <Link to="https://www.laimburg.it">
              <Text variant="bold" text="find_us" color="white"></Text>
            </Link>

          </Grid>
        </Grid>

      </Grid>


    </Container>
  );
}

